import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Lock } from 'lucide-react';
import { adminApi } from '../lib/api';

export default function AdminLogin() {
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await adminApi.post('/admin/auth', { username, password });
      nav('/admin');
    } catch (err) {
      setError(err.response?.data?.detail || 'Innlogging feilet');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A1F44] p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="w-12 h-12 bg-[#3B82F6]/10 rounded-xl flex items-center justify-center mb-5">
          <Lock size={22} className="text-[#3B82F6]" />
        </div>
        <h1 className="font-display text-2xl font-bold text-[#0A1F44] mb-1">Admin-innlogging</h1>
        <p className="text-sm text-[#64748B] mb-6">Specialists.no intern</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-[#0A1F44]/70 mb-1.5">Brukernavn</label>
            <input data-testid="admin-username" value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus className="w-full bg-[#FAF8F5] border-0 rounded-lg px-4 py-3 focus:outline-none" />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wider text-[#0A1F44]/70 mb-1.5">Passord</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full bg-[#FAF8F5] border-0 rounded-lg px-4 py-3 focus:outline-none" />
          </div>
          {error && <div className="text-sm text-red-600" data-testid="admin-login-error">{error}</div>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full bg-[#0A1F44] hover:bg-[#0A1F44]/90 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2">
            {loading ? <><Loader2 className="animate-spin" size={16} /> Logger inn…</> : 'Logg inn'}
          </button>
        </form>
      </div>
    </div>
  );
}
